<template>
  <div class="container" v-if="tags && tags.length > 0">
    <p class="label">{{ $t("dash.dictionary.tags.added") }}</p>

    <div class="tags">
      <span
        @click.prevent="$emit('tag-deleted', tag.id)"
        v-for="tag in tags"
        :key="tag.id"
        class="tag remove-tag"
        >#{{ tag.name }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AddedTags",
  props: {
    tags: { required: true }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 90%;
  margin: 16px auto;
  padding-left: 16px;
  padding-right: 16px;
  text-align: left;
  border-left: 1px solid rgb(49, 185, 190);
}

.label {
  margin-bottom: 8px;
}

.tags {
  padding: 0;
}
</style>
